import React from 'react'
import styled from 'styled-components'

interface buttonI {
  text: string
  link?: string
  backgroundColor?: string
  color?: string
}

const MenuLink: React.FC<buttonI> = ({ text, link, backgroundColor, color }) => {
  return (
    <StyledButton>
      {link != '' ? <LinkDiv href={link}>{text}</LinkDiv> : <Text>{text}</Text>}
    </StyledButton>
  )
}

const StyledButton = styled.div`
  display: flex;
  margin: 0 5px;
  justify-content: center;
  align-items: center;
  border: 2px solid transparent;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  @media (max-width: 900px) {
    margin: 5px;
  }
  &:hover {
    text-decoration: none;
    background-color: #63BCE5;
    color: #FFFFFF;
  }
`

const LinkDiv = styled.a`
  text-decoration: none;
  padding: 10px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: ease 0.5s;
  &:hover {
    text-decoration: none;
    background-color: #63BCE5;
    color: #FFFFFF;
  }
`

const Text = styled.div`
  display: flex;
  padding: 5px;
  font-size: 14px;
  transition: ease 0.5s;
  white-space: nowrap;
  &:hover {
    // text-decoration: none;
    // background-color: #63BCE5;
    // color: #FFFFFF;
  }
`

export default MenuLink
